export const ACTOR = {
    mbox: "",
    name: "",
    objectType: "Agent"
};

//VERBS
export let ANSWERED = {
    id: "http://adlnet.gov/expapi/verbs/answered",
    display: {
        "en-US" : "answered"
    }
};

export let RESULT = {
    score: {
        scaled: 0,
        min: 0,
        max: 0,
        raw: 0
    },
    success: true,
    completion: true,
    //duration: "",
    response: ""
};

export let BEST_SCORE = {
    scaled: 1,
    min: 0,
    max: 100,
    raw: 100
};

export let OK_SCORE = {
    scaled: 0.5,
    min: 0,
    max: 100,
    raw: 50
};

export let POOR_SCORE = {
    scaled: 0,
    min: 0,
    max: 100,
    raw: 0
};


export let DEFINITION = {

        name: {
            "en-US": "",
        },
        description: {
            "en-US": "",
        },
        type: 'http://adlnet.gov/expapi/activities/cmi.interaction',
        correctResponsesPattern: [],

};

export let ID_DESCRIPTION =  {
    id: {
        "en-US": "",
    },
    description: {
        "en-US": "",
    },
};




export let CHOICE_OBJECT = {
    id: "",
    objectType: "Activity",
    definition: Object.assign({}, DEFINITION, {
        interactionType : "choice",
        choices: []
    })
};


export let FILL_IN_OBJECT = {
    id: "",
    objectType: "Activity",
    definition: Object.assign({}, DEFINITION, {
        interactionType : "fill-in",
    })
};

export let MATCHING_OBJECT = {
    id: "",
    objectType: "Activity",
    definition: Object.assign({}, DEFINITION, {
        interactionType : "matching",
        choices: []
    })
};


//INTERACTION TYPE
//https://experienceapi.com/scorm-to-experience-api-xapi-cookbook/


export let CHOICE = {
    actor: ACTOR,
    verb: ANSWERED,
    result: RESULT,
    object: CHOICE_OBJECT
};


export let FILL_IN = {
    actor: ACTOR,
    verb: ANSWERED,
    result: RESULT,
    object: FILL_IN_OBJECT
};


/** WEBPACK FOOTER **
 ** ./src/models/xAPIModels.js
 **/